import { type AxiosRequestConfig } from 'axios'

const getAnnouncements = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/announcements/list'
  }
}

export { getAnnouncements }
